import { render } from "./base-clipboard.vue?vue&type=template&id=0ee3d260"
import script from "./base-clipboard.vue?vue&type=script&lang=js"
export * from "./base-clipboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__